import { render } from "./Cod2Page.vue?vue&type=template&id=08a9c992&scoped=true"
import script from "./Cod2Page.vue?vue&type=script&lang=js"
export * from "./Cod2Page.vue?vue&type=script&lang=js"

import "./Cod2Page.vue?vue&type=style&index=0&id=08a9c992&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9c992"]])

export default __exports__